import React, {useState} from "react";
import axios from "axios";
import { BaseUrl } from "../../../../Actions/Base";
import ResetPopupImg from "../Assets/ResetPopup.png";

const ResetPasswordSettingsPopup = ({setResetPasswordShowPopup, userEmail, setOtpVerificationShowPopup, email,
  setEmail }) => {
  const Border = "border-[#E2E2E2] border-[1px] border-solid";
  const isEditable = !userEmail; // no prop passed -> editable
  const [errorMessage, setErrorMessage] = useState("");

  const closePopup = () =>{
      console.log("Close icon clicked");
      setResetPasswordShowPopup(false);
  }

    const axiosInstance = axios.create({
      baseURL: BaseUrl,
      withCredentials: true,
    });

    const OpenOtpPopup = async () => {

      const finalEmail = userEmail || email;

      if (!finalEmail) {
        setErrorMessage("Please enter your email");
        return;
      }

    setErrorMessage(""); // clear any previous error before hitting the API

        const payload = {
          Email: finalEmail,
        };
      try {
        const res = await axiosInstance.post("/api/forgot-password", payload);
        console.log(res);
        if (res?.data?.success === true) {
          
          localStorage.setItem(
            "token",
            JSON.stringify(res?.data?.ResetPasswordToken)
          );
          setOtpVerificationShowPopup(true);
          setResetPasswordShowPopup(false);
        } else if (res?.data?.success === false) {
        }

      } catch (err) {
        console.log(err);
      }
    };
    
    return (
      <div className="fixed inset-0 z-[99] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md transition duration-500">
        <div className="relative rounded-[9px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[30px] pb-[30px] shadow-lg w-[340px] lg:w-[370px]">
            <div className="absolute top-2 right-2">
              <img
                className="absolute right-1 top-[4px] cursor-pointer"
                src={require("../Assets/Cross.svg").default}
                alt=""
                onClick={closePopup}
              />
            </div>

            <div  className="mt-[-120px] flex w-full justify-center items-center">
              <img
                src={ResetPopupImg}
                alt="img"
              />
            </div>

          <h2
            className=" mb-2 text-center text-[16px]"
          >
            Reset Password
          </h2>
          <p className="text-center text-[14px]">An OTP verification will be sent to your E-mail. Once verified you will be able to change your Password</p>
          <div className="flex flex-col gap-[5px] mt-[10px] mr-[15px] ml-[17px]">
                <label
                    htmlFor="Email"
                    className="text-[#404040] text-[14px]"
                >
                    Your E-mail
                </label>
                <input
                    type="text"
                    id="Email"
                    name="Email"
                    readOnly={!isEditable}
                    placeholder={isEditable ? "Enter your email" : ""}
                    value={isEditable ? email : userEmail}
                    onChange={(e) => isEditable && setEmail(e.target.value)}
                    className={`w-full rounded-md py-2  px-[10px] ${Border} text-bold shadow-[4px_5px_6px_#00000029] `}
                />
          </div>
          {errorMessage && <p className="text-[#ff0000] text-[16px]">{errorMessage} </p>}

          <div className="w-full flex flex-col ustify-center items-center gap-[15px] mt-[15px]">
            <button
                className="px-[15px] py-[7px] w-[90%] rounded-[6px] bg-[#A1A3EF] text-[#FFFFFF] text-[14px] cursor-pointer"
                onClick={OpenOtpPopup}
                style={{border:"2px solid #A1A3EF"}}>
                Reset Password
            </button>

            <p className="text-[14px] text-center cursor-pointer" onClick={closePopup}>Back</p>
          </div>
        </div>
      </div>
    );
  };

export default ResetPasswordSettingsPopup;
